import { QueryClient } from "react-query"

import { AxiosError } from "axios"

import { type StandardErrorType, defaultErrorHandler } from "../utils/ErrorHandling"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      onError: (e: unknown): void => {
        defaultErrorHandler(e as AxiosError<StandardErrorType>)
      },
    },
    mutations: {
      onError: (e: unknown): void => {
        defaultErrorHandler(e as AxiosError<StandardErrorType>)
      },
    },
  },
})
